module.exports = __webpack_public_path__ + "img/Group 709.ded5fcb6.svg";